import { concurrencyLimitReached } from '@/Analytics/Segment';

const recordConcurrencyError = (skylarkId: string | undefined, deviceId: string) => {
  concurrencyLimitReached({ content_id: skylarkId, device_id: deviceId });
};

export default recordConcurrencyError;
